import { Bubble } from './bubble';
import nls from '../../../nls/pt-BR.json';
import { Button } from '../../../../../../component';
import '../studyCreationGuide.scss';
import { useDispatch } from 'react-redux';
import { advanceToStep } from '../../../redux/studies.reducer';

export const InitialState: React.FC = () => {
  const dispatch = useDispatch();
  const handleNextStep = () => {
    dispatch(advanceToStep('dragAndDropInstructions'));
  };
  return (
    <>
      <h6 className="study-creation-title">{nls.studyCreationGuide.title}</h6>
      <div className="initial-state">
        <span className="vertical-line"></span>
        <section>
          <div className="section-title">
            <Bubble type="inactive">1</Bubble>
            <span>{nls.studyCreationGuide.sectionTitles.step1}</span>
          </div>
        </section>
        <section>
          <div className="section-title">
            <Bubble type="inactive">2</Bubble>
            <span>{nls.studyCreationGuide.sectionTitles.step2}</span>
          </div>
          <div className="section-subtitles">
            <p>
              {nls.studyCreationGuide.sectionSubtitles.offeredRealtiesAnalysis}
            </p>
            <p>
              {nls.studyCreationGuide.sectionSubtitles.enterpiseUnitsValuation}
            </p>
          </div>
        </section>
        <section>
          <div className="section-title">
            <Bubble type="inactive">3</Bubble>
            <span>{nls.studyCreationGuide.sectionTitles.step3}</span>
          </div>
          <div className="section-subtitles">
            <p>
              {nls.studyCreationGuide.sectionSubtitles.offeredRealtiesAnalysis}
            </p>
            <p>
              {nls.studyCreationGuide.sectionSubtitles.enterpiseUnitsValuation}
            </p>
          </div>
        </section>
        <section>
          <div className="section-title">
            <Bubble type="inactive">4</Bubble>
            <span>{nls.studyCreationGuide.sectionTitles.step4}</span>
          </div>
        </section>
        <section>
          <div className="section-title">
            <Bubble type="inactive">5</Bubble>
            <span>{nls.studyCreationGuide.sectionTitles.step5}</span>
          </div>
          <div className="section-subtitles">
            <p>{nls.studyCreationGuide.sectionSubtitles.installments}</p>
            <p>{nls.studyCreationGuide.sectionSubtitles.ablePublic}</p>
          </div>
        </section>
        <section>
          <div className="section-title">
            <Bubble type="inactive">6</Bubble>
            <span>{nls.studyCreationGuide.sectionTitles.step6}</span>
          </div>
          <div className="section-subtitles">
            <p>
              {
                nls.studyCreationGuide.sectionSubtitles
                  .transactionsAndMigratoryAnalysis
              }
            </p>
            <p>{nls.studyCreationGuide.sectionSubtitles.marketCycleAnalysis}</p>
          </div>
        </section>
        <section>
          <div className="section-title">
            <Bubble type="inactive">7</Bubble>
            <span>{nls.studyCreationGuide.sectionTitles.step7}</span>
          </div>
        </section>
      </div>
      <Button
        className="btn normal primary"
        cy="StudyCreationGuideStart"
        style={{ width: '100%' }}
        onClick={handleNextStep}
      >
        {nls.studyCreationGuide.start}
      </Button>
    </>
  );
};
